<template lang="html">
  <div class="vh-100 InactiveScreen">
    <div class="contentContainer">
      <img src="@/assets/looser.png" class="image" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  name: "LooserScreen",
  created() {
    // this.timer = setInterval(this.gameEnd, 10000);
  },
  methods: {
    gameEnd: function () {
      let data = this.$store.getters.getGame;
      // data.has_ended = true;
      this.$store.dispatch("updateActiveGame", data);
    },
  },
};
</script>

<style lang="css" scoped>
html,
body {
  height: 100%;
  margin: 0px;
  padding: 0px;
}
.InactiveScreen {
  background: url("~@/assets/bg_green_purple.jpg") no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 100%;
}
.image {
  width: 80%;
}
.contentContainer {
  padding-top: 25%;
}
</style>
